export default __webpack_public_path__ + "static/media/FeverInTheOceans_06.5877ec08.png";